import { render, staticRenderFns } from "./AcessoRapido.vue?vue&type=template&id=b4685c6e&scoped=true&lang=pug"
import script from "./AcessoRapido.vue?vue&type=script&lang=js"
export * from "./AcessoRapido.vue?vue&type=script&lang=js"
import style0 from "./AcessoRapido.vue?vue&type=style&index=0&id=b4685c6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4685c6e",
  null
  
)

export default component.exports